import { render, staticRenderFns } from "./ProjectTagSelector.vue?vue&type=template&id=64011d72&scoped=true&"
import script from "./ProjectTagSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectTagSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTagSelector.vue?vue&type=style&index=0&id=64011d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64011d72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VChip,VDivider,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
